<app-dark-back-button *ngIf="showBackButton$ | async" (backClicked)="goBack()" [paddingBottomRem]="2" />

<app-logo class="css-logo" [logoImage]="'assets/logo/dark/css-logo.svg'" />

<ng-container [ngSwitch]="authFlow$ | async">
  <!--  Sign In Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.SignIn">
    <app-sign-in (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Forgot Password Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.ForgotPassword">
    <app-forgot-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Reset Password Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.ResetPassword">
    <app-reset-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Internal User Choose Password Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.InternalUserChoosePassword">
    <app-internal-user-choose-password />
  </ng-container>
  <!--  Internal User Setup MFA Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.InternalUserSetupMfa">
    <app-internal-user-auth-setup />
  </ng-container>
  <!--  Internal User Verify Code Flow  -->
  <ng-container *ngSwitchCase="InternalUserAuthFlow.InternalVerifyCode">
    <app-internal-user-verify-code (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
</ng-container>
